import type { SVGProps } from 'react';

const SvgAnnotationErase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 5H8.24c-1.14 0-2.17.64-2.68 1.66l-2.01 4c-.42.84-.42 1.84 0 2.68l2 4A2.99 2.99 0 0 0 8.23 19h9.76c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3zm1 11c0 .55-.45 1-1 1H8.24c-.38 0-.72-.21-.89-.55l-2-4a1 1 0 0 1 0-.89l2-4c.17-.34.51-.55.89-.55H18c.55 0 1 .45 1 1v8z"
    />
    <path
      fill="currentcolor"
      d="M15.71 9.29a.996.996 0 0 0-1.41 0l-1.29 1.29-1.29-1.29a.996.996 0 1 0-1.41 1.41l1.29 1.29-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l1.29-1.29 1.29 1.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-1.29-1.29 1.29-1.29a.996.996 0 0 0 0-1.41z"
    />
  </svg>
);
export default SvgAnnotationErase;
